<template>
  <div>
    <el-table
      v-bind:data="displayActivity"
      :show-header="false"
      row-key="id"
      @row-click="selectRow"
      :expand-row-keys="expand"
      empty-text="No exercise, yoga, or mindfulness recorded"
      style="width: 100%"
    >
      <!-- Expandable message history list -->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <ActivityAnalysis
            v-if="scope.row.id === 'physical activity'"
            :event="scope.row.event"
          >
          </ActivityAnalysis>
          <ActivityContentAnalysis
            v-else
            :id="scope.row.id"
            :type="scope.row.id"
            :event="scope.row.event"
          >
          </ActivityContentAnalysis>
          <!-- <pre>{{ JSON.stringify(scope.row.event, null, 4) }}</pre> -->
        </template>
      </el-table-column>

      <el-table-column width="50">
        <template slot-scope="scope">
          <img
            class="activity-icon"
            :src="require(`./image/${scope.row.id.replace(' ', '_')}.png`)"
          />
        </template>
      </el-table-column>

      <el-table-column prop="title" width="200">
        <template slot-scope="scope">
          <div style="line-height:16px">
            <strong style="text-transform:capitalize">{{ scope.row.id }}</strong
            ><br />
            <small>{{ formatCount(scope.row.event.length, "time") }}</small>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="200">
        <template slot-scope="scope">
          <DateRange :row="scope.row" :patient="patient"></DateRange>
        </template>
      </el-table-column>

      <el-table-column>
        <template slot-scope="scope">
          <div>
            <!-- graph -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="show-more" v-if="showRows < activity.length">
      <el-button type="text" @click="showMore">
        {{ showMoreText }}&nbsp;<i class="el-icon-arrow-down"></i>
      </el-button>
    </div>
    <div class="show-more" v-if="showRows >= activity.length && this.showLess">
      <el-button type="text" @click="showLessHandler">
        {{ showLessText }}&nbsp;<i class="el-icon-arrow-up"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import CardTable from "../component/table";
import { mapState, mapGetters, mapActions } from "vuex";
import ActivityAnalysis from "./analysis/activity/Analysis";
import ActivityContentAnalysis from "./analysis/activity/ContentAnalysis";

const PHYSICAL_ACTIVITY = ["walk", "hike", "swim", "run", "bike", "other"];

export default {
  name: "patient-activity-card-table",
  extends: CardTable,

  props: {
    patient: {
      type: Object,
      required: true,
    },
    exercise: {
      type: Array,
    },
    yoga: {
      type: Array,
    },
    mindfulness: {
      type: Array,
    },
  },

  data() {
    return {
      showLess: false,
      showRows: 3,
    };
  },

  methods: {
    activityMap(events) {
      if (!Array.isArray(events)) return {};

      // Create a mapping of all event types
      var type = {};
      events.forEach((event) => {
        let t = event.type.split(":");

        // Set a special flag for physical activity
        if (t[0] == "exercise" && PHYSICAL_ACTIVITY.includes(t[1]))
          t = "physical activity";
        // Otherwise use the event type
        else t = t[0];

        if (!type[t])
          type[t] = {
            id: t,
            event: [],
          };
        type[t].event.push(event);
      });

      // Sort all underlying events for each type
      var typeMap = Object.keys(type).map((t) => {
        type[t].event = type[t].event.sort((a, b) => a.id.localeCompare(b.id));
        return type[t];
      });

      // Sort each id into order by frequency
      if (this.ascending)
        return typeMap.sort((a, b) => a.event.length - b.event.length);
      else if (this.descending)
        return typeMap.sort((a, b) => b.event.length - a.event.length);
      else return typeMap;
    },

    showMore() {
      this.showLess = true;
      this.showRows += 10;
    },
    showLessHandler() {
      this.showLess = false;
      this.showRows = 3;
    },
  },

  computed: {
    ...mapGetters("content", ["getContent", "getContentKey"]),
    activity() {
      return this.activityMap(
        this.exercise.concat(this.yoga).concat(this.mindfulness)
      );
    },
    displayActivity() {
      return this.activity.slice(0, this.showRows);
    },
    showMoreText() {
      return "Show more";
    },
    showLessText() {
      return "Show less";
    },
  },

  components: {
    ActivityAnalysis,
    ActivityContentAnalysis,
  },
};
</script>

<style lang="scss" scoped>
.show-more {
  .el-button, .el-button:hover, .el-button:focus {
    display: block;
    width: 100%;
    font-size: 14px;
    color: #4a9bf9;
    font-weight: 600;
  }
  .el-icon-arrow-down {
    font-weight: 700;
  }
}

.activity-icon {
  float: left;
  width: 30px;
  height: 30px;
}
</style>
